export const ChatButtonToolType = {
  PROMPT_LIBRARY_TRIGGER: "PROMPT_LIBRARY_TRIGGER",
  PROMPT_LIBRARY_SUGGESTION: "PROMPT_LIBRARY_SUGGESTION",
};
